module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/THE-LAKEHOUSE.2b268a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/THE-LAKEHOUSE.jpg
// module id = rpqK
// module chunks = 0